import { render, staticRenderFns } from "./GridItens.vue?vue&type=template&id=d4b24f0a&scoped=true"
import script from "./GridItens.vue?vue&type=script&lang=js"
export * from "./GridItens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b24f0a",
  null
  
)

export default component.exports